import { Megaphone } from "lucide-react";
import { mediaUrl } from "../api";

export function AdSlot({ label = "Advertisement", size = "wide", ad = null }) {
  const heightClass = size === "frontpage" ? "min-h-56 sm:min-h-72" : size === "square" ? "min-h-64" : size === "sidebar" ? "min-h-80" : "min-h-28";
  const isFrontpage = size === "frontpage";
  const image = mediaUrl(ad?.media?.url);
  const content = ad ? (
    <div className="relative h-full min-h-56 w-full overflow-hidden sm:min-h-72" data-testid="frontpage-ad-live-content">
      {image && ad.media?.media_type === "image" ? (
        <img src={image} alt={ad.title} className="absolute inset-0 h-full w-full object-cover" data-testid="frontpage-ad-live-image" />
      ) : (
        <div className="absolute inset-0 bg-blue-950" data-testid="frontpage-ad-live-background" />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-950/90 via-blue-950/65 to-green-950/25" data-testid="frontpage-ad-live-overlay" />
      <div className="relative flex h-full min-h-56 max-w-3xl flex-col justify-center p-6 text-left text-white sm:min-h-72 sm:p-10" data-testid="frontpage-ad-live-text">
        <p className="text-sm font-black uppercase tracking-[0.22em] text-green-200" data-testid="frontpage-ad-live-label">Sponsored</p>
        <h2 className="mt-3 text-3xl font-black leading-tight sm:text-5xl" data-testid="frontpage-ad-live-title">{ad.title}</h2>
        {ad.description && <p className="mt-4 text-base font-bold leading-relaxed text-blue-50" data-testid="frontpage-ad-live-description">{ad.description}</p>}
        {ad.link_url && <span className="mt-5 inline-flex w-fit border border-white/70 px-4 py-2 text-sm font-black" data-testid="frontpage-ad-live-cta">Visit Advertiser</span>}
      </div>
    </div>
  ) : null;
  return (
    <aside
      className={`flex ${heightClass} items-center justify-center border ${isFrontpage ? "border-blue-900 bg-white p-6 shadow-md" : "border-dashed border-slate-300 bg-white/85 p-5 shadow-sm"} text-center`}
      data-testid={`ad-slot-${size}`}
      aria-label={label}
    >
      {isFrontpage && ad?.link_url ? (
        <a href={ad.link_url} target="_blank" rel="noreferrer" className="block h-full w-full focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2" data-testid="frontpage-ad-live-link">{content}</a>
      ) : isFrontpage && ad ? content : (
      <div className={`${isFrontpage ? "w-full space-y-4" : "space-y-2"}`} data-testid={`ad-slot-${size}-content`}>
        <Megaphone className={`${isFrontpage ? "h-10 w-10" : "h-6 w-6"} mx-auto text-green-800`} aria-hidden="true" />
        <p className={`${isFrontpage ? "text-base sm:text-lg" : "text-sm"} font-black uppercase tracking-[0.2em] text-slate-500`} data-testid={`ad-slot-${size}-label`}>{label}</p>
        {isFrontpage ? (
          <>
            <h2 className="text-3xl font-black leading-tight text-blue-950 sm:text-5xl" data-testid="frontpage-ad-title">Advertise Your Business Here</h2>
            <p className="mx-auto max-w-2xl text-base font-bold leading-relaxed text-slate-600" data-testid="frontpage-ad-description">V.T.C Tamil / www.Vanniyantamil.com வாசகர்களிடம் உங்கள் விளம்பரத்தை பெரிய பேனராக காட்டுங்கள்.</p>
            <div className="mx-auto mt-2 grid max-w-3xl grid-cols-3 border border-slate-200 bg-slate-50 text-xs font-black uppercase tracking-[0.12em] text-slate-500" data-testid="frontpage-ad-size-row">
              <span className="border-r border-slate-200 px-3 py-3" data-testid="frontpage-ad-size-desktop">Desktop Banner</span>
              <span className="border-r border-slate-200 px-3 py-3" data-testid="frontpage-ad-size-mobile">Mobile Banner</span>
              <span className="px-3 py-3" data-testid="frontpage-ad-size-home">Homepage Top</span>
            </div>
          </>
        ) : (
          <p className="text-xs font-semibold text-slate-500" data-testid={`ad-slot-${size}-description`}>விளம்பர இடம்</p>
        )}
      </div>
      )}
    </aside>
  );
}